import { IconButton, Flex, Box } from '@everlywell/ui-kit';
import { ArrowLeft } from '@phosphor-icons/react';
import { motion } from 'framer-motion';
import React from 'react';
import { QuestLocation } from 'utils/api/questApis';

import { ANIMATION_DURATION } from '../../QuestLocationFinder.constants';
import QuestLocationCard from '../QuestLocationCard';

interface PatientServiceCenterLocationProps {
  selectedLocation: QuestLocation | null;
  handleBackClick: () => void;
  widgetState: 'landing' | 'list' | 'listItem';
}

const PatientServiceCenterLocation = (
  props: PatientServiceCenterLocationProps,
) => {
  const { selectedLocation, handleBackClick, widgetState } = props;

  return (
    <Flex
      as={motion.div}
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        justifyContent: 'space-between',
      }}
      initial={{ display: 'none' }}
      animate={
        {
          landing: {
            opacity: 0,
            display: 'none',
            transform: 'translateY(10%)',
          },
          list: {
            opacity: 0,
            display: 'none',
            transform: 'translateY(10%)',
            transition: {
              type: 'tween',
              duration: ANIMATION_DURATION,
            },
          },
          listItem: {
            display: 'flex',
            opacity: 1,
            transform: 'translateY(0)',
            transition: {
              type: 'tween',
              duration: ANIMATION_DURATION,
            },
          },
        }[widgetState]
      }
    >
      <Box>
        <IconButton
          icon={<ArrowLeft />}
          aria-label="back to all locations button"
          variant={'primary'}
          colorScheme="whiteCS"
          size={'sm'}
          onClick={handleBackClick}
        />
      </Box>
      {selectedLocation && <QuestLocationCard location={selectedLocation} />}
    </Flex>
  );
};

export default PatientServiceCenterLocation;
